/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';

import * as actionTypes from './actionTypes';
import * as serviceEndPoint from '../../../../SharedModules/services/service';

export const dispatchGetGeneralSystemParametersResultDetails = (data) => ({
  type: actionTypes.GET_GENERAL_SYSTEM_PARAMETER,
  generalSystemParameter: data,
});
export const dispatchGetMDspectheraCodeDetails = (data) => ({
  type: actionTypes.GET_MD_SPEC_THERA,
  mdspecthera: data,
});
export const dispatchSetMDspectheraCodeDetails = (payload) => ({
  type: actionTypes.SET_MD_SPEC_THERA,
  payload,
});
export const dispatchSetSpecInSys = (payload) => ({
  type: actionTypes.SET_SPEC_IN_SYS,
  payload,
});
export const dispatchHolidaysDetails = (data) => ({
  type: actionTypes.GET_HOLIDAY,
  holiday: data?.map((item) => {
    item.id = uuidv4();
    return item;
  }),
});
export const dispatchSetHolidaysDetails = (payload) => ({
  type: actionTypes.SET_HOLIDAY,
  payload,
});

export const dispatchupdateHolidayDetails = (data) => ({
  type: actionTypes.UPDATE_HOLIDAY,
  holidayUpdateData: data,
});

export const dispatchNMAccountDetails = (data) => ({
  type: actionTypes.GET_NM_ACCOUNT_NUMBER,
  nmAccountNumber: data,
});
export const setNMAccInSys = (payload) => ({
  type: actionTypes.SET_NM_ACC_IN_SYS,
  payload,
});
export const dispatchNMFinCodes = (data) => ({
  type: actionTypes.GET_NM_FIN_CODE,
  nmFinCodes: data,
});
export const setNMFinInSys = (payload) => ({
  type: actionTypes.SET_NM_FIN_IN_SYS,
  payload,
});
export const dispatchNMFinCodeDataToUpdate = (data) => ({
  type: actionTypes.GET_NM_FIN_CODE,
  nmFinCodeUpdate: data,
});

export const dispatchDefaultAuditDetails = (data) => ({
  type: actionTypes.GET_DEFAULT_AUDIT,
  defaultAudit: data,
});

export const dispatchupdateMDspectheraCodeDetails = (data) => ({
  type: actionTypes.UPDATE_MD_SPEC_THERA,
  updateMDSpectheraDetails: data,
});

export const dispatchupdateNMAccountDetails = (data) => ({
  type: actionTypes.UPDATE_NM_ACCOUNT_NUMBER,
  updateNMAccountDetails: data,
});

export const dispatchupdateNMFineCodeDetails = (data) => ({
  type: actionTypes.UPDATE_NM_FINE_CODE,
  updateNMFineCodeDetails: data,
});
export const dispatchupdateSystemDetails = (data) => ({
  type: actionTypes.UPDATE_SYSTEM_PARAM,
  updatedSystemDetails: data,
});

export const setSystemParameterPayloadRedux = (data) => ({
  type: actionTypes.SET_SYSTEM_PARAMETER_PAYLOAD,
  systemParameterPayload: data,
});
export const setDefaultAuditData = (data) => ({
  type: actionTypes.SET_DEFAULT_AUDIT_DATA,
  defaultAuditDataRedux: data,
});
export const setGenSysParamDataRedux = (data) => ({
  type: actionTypes.SET_GEN_SYS_PARAM_DATA,
  genSysParamData: data,
});
export const setDefaultSysParamDataRedux = (data) => ({
  type: actionTypes.SET_DEF_SYS_PARAM_DATA,
  defSysParamData: data,
});

export const dispatchErrorMessages = (payload) => ({
  type: actionTypes.SET_ERROR_MESSAGES,
  payload,
});
export const dispatchSuccessMessage = (payload) => ({
  type: actionTypes.SET_SUCCESS_MESSAGES,
  payload,
});

export const dispatchTabValue = (payload) => ({
  type: actionTypes.SET_TAB_VALUE,
  payload,
});
export const dispatchDisabledSaveCancelBtn = (payload) => ({
  type: actionTypes.SET_DISABLED_SAVE_CANCEL_BTN,
  payload,
});
export const resetSystemParameterStore = () => ({
  type: actionTypes.RESET_SYSTEM_PARAMETER_STORE,
});
// selected Code dispatch
export const dispatchSelectedCode = (data) => ({
  type: actionTypes.SELECTED_UNIT_DEFAULT_CODE,
  payload: data,
});

export const dispatchValidateNmFinCd = (data) => ({
  type: actionTypes.VALIDATE_NMFIN_CODE,
  payload: data,
});

export const dispatchValidateNmAccountNumber = (data) => ({
  type: actionTypes.VALIDATE_NMACCOUNT_NUMBER,
  payload: data,
});

export const validateNmAccountNumber = (startQtr) => (dispatch) => {
  const qtrToDelete = { startQtr };
  return axios
    .post(serviceEndPoint.VALIDATE_NMACCOUNT_NUMBER, qtrToDelete)
    .then((response) => {
      dispatch(dispatchValidateNmAccountNumber(response?.data));
    })
    .catch((error) => {
      dispatch(dispatchValidateNmAccountNumber(error));
    });
};

export const validateNmFinCd = (startQtr) => (dispatch) => {
  const qtrToDelete = { startQtr };
  return axios
    .post(serviceEndPoint.VALIDATE_NMACCOUNT_NUMBER, qtrToDelete)
    .then((response) => {
      dispatch(dispatchValidateNmFinCd(response?.data));
    })
    .catch((error) => {
      dispatch(dispatchValidateNmFinCd(error));
    });
};

export const getgeneralsystemparameterDetails = (values) => (dispatch) => {
  return axios
    .get(serviceEndPoint.GET_GENERAL_SYSTEM_PARAMETER, values)
    .then((response) => {
      dispatch(
        dispatchGetGeneralSystemParametersResultDetails(response?.data?.data)
      );
    })
    .catch((error) => {
      dispatch(dispatchGetGeneralSystemParametersResultDetails(error.response));
    });
};

export const getMDspectheraCodeDetails = (values) => (dispatch) => {
  return axios
    .get(serviceEndPoint.GET_MD_SPEC_THERA, values)
    .then((response) => {
      dispatch(dispatchGetMDspectheraCodeDetails(response.data));
    })
    .catch((error) => {
      dispatch(dispatchGetMDspectheraCodeDetails(error.response.data));
    });
};

export const getDefaultAuditDetails = () => (dispatch) => {
  return axios
    .get(serviceEndPoint.GET_DEFAULT_AUDIT)
    .then((response) => {
      dispatch(dispatchDefaultAuditDetails(response.data));
    })
    .catch((error) => {
      dispatch(dispatchDefaultAuditDetails(error.response));
    });
};

export const getNMAccountDetails = (values) => (dispatch) => {
  return axios
    .get(serviceEndPoint.GET_NM_ACCOUNT_NUMBER, values)
    .then((response) => {
      dispatch(dispatchNMAccountDetails(response.data.data));
    })
    .catch((error) => {
      dispatch(dispatchNMAccountDetails(error.response));
    });
};

export const getNMFinCode = (values) => (dispatch) => {
  return axios
    .get(serviceEndPoint.GET_NM_FIN_CODE, values)
    .then((response) => {
      dispatch(dispatchNMFinCodes(response.data));
    })
    .catch((error) => {
      dispatch(dispatchNMFinCodes(error.response));
    });
};

export const getMaxActivityDt = () => (dispatch) => {
  return axios
    .get(serviceEndPoint.GET_MAX_ACTIVITY_LIST)
    .then((response) => {
      const dateList = response.data;
      const maxdt = dateList.reduce((prev, next) => {
        let pre = new Date(prev);
        let nex = new Date(next);
        return pre > nex ? pre : nex;
      });
      dispatch({ type: actionTypes.MAX_DT_AR_ACTIVITY, payload: maxdt });
    })
    .catch(() => {
      dispatch({ type: actionTypes.MAX_DT_AR_ACTIVITY, payload: '' });
    });
};

export const updateMDSpecTheraDetails = (values) => (dispatch) => {
  return axios
    .post(serviceEndPoint.UPDATE_MD_SPEC_THERA, values)
    .then((response) => {
      dispatch(dispatchupdateMDspectheraCodeDetails(response.data.data));
    })
    .catch((error) => {
      dispatch(dispatchupdateMDspectheraCodeDetails(error.response));
    });
};

export const getHolidaysDetails = (values) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_HOLIDAY, values)
    .then((response) => {
      dispatch(dispatchHolidaysDetails(response.data.data));
    })
    .catch((error) => {
      dispatch(dispatchHolidaysDetails(error.response));
    });
};

export const updateHolidayDetails = (values) => (dispatch) => {
  return axios
    .post(serviceEndPoint.UPDATE_HOLIDAY, values)
    .then((response) => {
      dispatch(dispatchupdateHolidayDetails(response.data.data));
      return response.data;
    })
    .catch((error) => {
      dispatch(dispatchupdateHolidayDetails(error.response));
      return error.response;
    });
};

export const updateNMAccountDetails = (values) => (dispatch) => {
  return axios
    .post(serviceEndPoint.UPDATE_NM_ACCOUNT_NUMBER, values)
    .then((response) => {
      dispatch(dispatchupdateNMAccountDetails(response.data.data));
    })
    .catch((error) => {
      dispatch(dispatchupdateNMAccountDetails(error.response));
    });
};
export const updateNMFineCdDetails = (values) => (dispatch) => {
  return axios
    .post(serviceEndPoint.UPDATE_NM_FIN_CODE, values)
    .then((response) => {
      dispatch(dispatchupdateNMFineCodeDetails(response.data));
    })
    .catch((error) => {
      dispatch(dispatchupdateNMFineCodeDetails(error.response));
    });
};
export const updateSystemDetails = (values) => (dispatch) => {
  return axios
    .post(serviceEndPoint.UPDATE_SYSTEM, values)
    .then((response) => {
      dispatch(dispatchupdateSystemDetails(response.data));
    })
    .catch((error) => {
      dispatch(dispatchupdateSystemDetails(error.response));
    });
};

// selected code
export const getSelectedCode = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_REFERENCE_DATA, value)
    .then((response) => {
      return dispatch(dispatchSelectedCode(response.data));
    })
    .catch((err) => {
      dispatch(dispatchSelectedCode([err.data]));
    });
};
export const updateDefaultAuditData = (data)=>({
type: actionTypes.UPDATE_DEFAULT_AUDIT_DATA,
payload:data,
})